// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1M5QC","errors":"Errors_errors__3cef8"};